const languageConstants = {
    AR: "ar",
    EN: "en",
};

export default languageConstants;